import { useState, useEffect } from "react";

export default function useHiddenColumns(tableSelector, headers) {
  const [hiddenFields, setHiddenFields] = useState([]);

  useEffect(() => {
    // const compute = () => {
    //   const tableEl = document.querySelector(tableSelector);
    //   if (!tableEl) return;

    //   const hidden = headers
    //     .filter(({ className }) => {
    //       const el = tableEl.querySelector(`.${className}`);
    //       if (!el) return false;
    //       return window.getComputedStyle(el).display === "none";
    //     })
    //     .map(({ className, label , field}) => ({
    //       field:field || className.replace("col-", ""),
    //       label,
    //     }));

    //   setHiddenFields(hidden);
    // };
    const compute = () => {
      const tableEl = document.querySelector(tableSelector);
      if (!tableEl) return;

      const hidden = headers
        .filter(({ className }) => {
           if (!className) return false;
          // multiple classes irundhaalum correct compound selector build pannum
          const selector = "." + className.trim().split(/\s+/).join(".");
          const el = tableEl.querySelector(selector);
          if (!el) return false;
          return window.getComputedStyle(el).display === "none";
        })
        .map(({ field, label }) => ({ field, label }));

      setHiddenFields(hidden);
    };
    compute();
    window.addEventListener("resize", compute);

    const sidebarEl = document.querySelector(".sidebar");
    const observer = sidebarEl ? new MutationObserver(compute) : null;
    if (sidebarEl && observer) {
      observer.observe(sidebarEl, { attributes: true, attributeFilter: ["class"] });
    }

    return () => {
      window.removeEventListener("resize", compute);
      observer?.disconnect();
    };
  }, [tableSelector, headers]);

  return hiddenFields;
}